import Vue from 'vue'
import VueRouter from 'vue-router'
import RequestTypeList from 'components/RequestTypeList'
import RequestTypeDetail from 'components/RequestTypeDetail'
import GroupList from 'components/GroupList'
import GroupDetail from 'components/GroupDetail'
import FormFieldDetail from 'components/FormFieldDetail'
import FormSectionDetail from 'components/FormSectionDetail'
import WorkflowList from 'components/WorkflowList'
import WorkflowDetail from 'components/WorkflowDetail'
import WorkflowRequests from 'components/WorkflowRequests'
import Login from 'components/Login'
import Signup from 'components/Signup'
import PasswordReset from 'components/PasswordReset'
import RequestConfirmation from 'components/RequestConfirmation'
import RequestDetail from 'components/RequestDetail'
import RequestInvite from 'components/RequestInvite'
import RequestInviteSelect from 'components/RequestInviteSelect'
import RequestList from 'components/RequestList'
import RequestForm from 'components/RequestForm'
import UserProfile from 'components/UserProfile'
import RequestOpen from 'components/RequestOpen'
import Management from 'components/Management'
import Message from 'components/util/Message'
import StepFieldList from 'components/StepFieldList'
import StepFieldDetail from 'components/StepFieldDetail'
import UserList from 'components/UserList'
import UserImport from 'components/UserImport'
import StepActionList from 'components/StepActionList'
import StepActionDetail from 'components/StepActionDetail'
import StepGroupRuleList from 'components/StepGroupRuleList'

import {
  Parse
} from '../Global'

Vue.use(VueRouter)

let router = new VueRouter({
  routes: [
    {
      path: '/requestTypes',
      name: 'RequestTypeList',
      component: RequestTypeList
    },
    {
      path: '/requestType/:id',
      name: 'RequestTypeDetail',
      component: RequestTypeDetail
    },
    {
      path: '/groups',
      name: 'GroupList',
      component: GroupList
    },
    {
      path: '/group/:id',
      name: 'GroupDetail',
      component: GroupDetail
    },
    {
      path: '/formField/:reqType/:section/:id?',
      name: 'FormFieldDetail',
      component: FormFieldDetail
    },
    {
      path: '/formSection/:reqType/:id?',
      name: 'FormSectionDetail',
      component: FormSectionDetail
    },
    {
      path: '/workflows',
      name: 'WorkflowList',
      component: WorkflowList
    },
    {
      path: '/workflow/:id?',
      name: 'WorkflowDetail',
      component: WorkflowDetail
    },
    {
      path: '/workflow/:id/requests',
      name: 'WorkflowRequests',
      component: WorkflowRequests
    },
    {
      path: '/login/:access_token?',
      name: 'Login',
      component: Login,
      meta: { allowAnonymous: true }
    },
    {
      path: '/signup/',
      name: 'Signup',
      component: Signup,
      meta: { allowAnonymous: true }
    },
    {
      path: '/password-reset/',
      name: 'PasswordReset',
      component: PasswordReset,
      meta: { allowAnonymous: true }
    },
    {
      path: '/request/:id',
      name: 'RequestDetail',
      component: RequestDetail
    },
    {
      path: '/invite/:requestId/:stepId',
      name: 'RequestInvite',
      component: RequestInvite
    },
    {
      path: '/invite/:requestId/:stepId/select',
      name: 'RequestInviteSelect',
      component: RequestInviteSelect
    },
    {
      path: '/requests',
      name: 'RequestList',
      component: RequestList
    },
    {
      path: '/requestConfirmation/:requestId',
      name: 'RequestConfirmation',
      component: RequestConfirmation
    },
    {
      path: '/requestForm/:workflowId',
      name: 'RequestForm',
      component: RequestForm
    },
    {
      path: '/',
      name: 'Home',
      component: RequestOpen
    },
    {
      path: '/openRequest/:tag?',
      name: 'RequestOpen',
      component: RequestOpen
    },
    {
      path: '/management',
      name: 'Management',
      component: Management
    },
    {
      path: '/userProfile',
      name: 'UserProfile',
      component: UserProfile
    },
    {
      path: '/message/:message',
      name: 'Message',
      component: Message,
      meta: { allowAnonymous: true }
    },
    {
      path: '/stepFieldList/:stepId/:actionId?',
      name: 'StepFieldList',
      component: StepFieldList
    },
    {
      path: '/stepFieldDetail/:stepId/:id?/:actionId?',
      name: 'StepFieldDetail',
      component: StepFieldDetail
    },
    {
      path: '/users',
      name: 'UserList',
      component: UserList
    },
    {
      path: '/users/import',
      name: 'UserImport',
      component: UserImport
    },
    {
      path: '/stepActionList/:stepId',
      name: 'StepActionList',
      component: StepActionList
    },
    {
      path: '/stepActionDetail/:stepId/:id?',
      name: 'StepActionDetail',
      component: StepActionDetail
    },
    {
      path: '/stepGroupRuleList/:stepId',
      name: 'StepGroupRuleList',
      component: StepGroupRuleList
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   let user = Parse.User.current()
//   if (to.name !== 'Login' && !user) {
//     next('/login')
//   } else {
//     next()
//   }
// })
let getQueryString = (field, to) => {
  let href = to.path // window.location.href
  let reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i')
  let string = reg.exec(href)
  return string ? string[1] : null
}

router.beforeEach((to, from, next) => {
  let accessToken = getQueryString('access_token', to)
  if (accessToken) {
    next('/login/' + accessToken)
  } else {
    let user = Parse.User.current()
    if (!to.meta.allowAnonymous && !user) {
      next('/login?next=' + (to.query.next || ''))
    } else if (to.query.next && user) {
      next(to.query.next)
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js